import React from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import Cards from 'components/Card';
import { COLUMNS_LIMIT } from 'variables/main';

const ContentWrapper = styled('section')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: 85,
  [theme.breakpoints.down('md')]: {
    marginBottom: 50
  },
  [theme.breakpoints.down('sm')]: {
    marginBottom: 35
  }
}));

const Title = styled(Typography)(({ theme }) => ({
  paddingBottom: 25,
  fontSize: 24,
  [theme.breakpoints.down('md')]: {
    lineHeight: '34px'
  }
}));

const ButtonStyled = styled(Button)(() => ({
  alignSelf: 'center',
  marginTop: 35
}));

const SimilarProfessionsComponent = ({ professionInfo, t }) => {
  const [page, setPage] = React.useState(1);

  const handleLoad = React.useCallback(async () => {
    setPage(page + 1);
  }, [page]);

  const count = React.useMemo(
    () => (professionInfo.similarOccupations || []).length,
    [professionInfo]
  );

  const list = React.useMemo(() => {
    return (professionInfo.similarOccupations || [])?.slice(0, COLUMNS_LIMIT * page);
  }, [professionInfo.similarOccupations, page]);

  const limitReached = React.useMemo(() => count <= page * COLUMNS_LIMIT, [count, page]);

  if (!professionInfo) return null;

  return (
    <ContentWrapper>
      <Title variant={'h2'}>{t('SimilarProfessions')}</Title>

      <Cards list={list} />

      {limitReached ? null : (
        <ButtonStyled
          aria-label={t('MoreProfessions')}
          variant="contained"
          color="primary"
          onClick={handleLoad}>
          {t('MoreProfessions')}
        </ButtonStyled>
      )}
    </ContentWrapper>
  );
};

export default SimilarProfessionsComponent;
